export const escapeHTML = (str) => {
    const entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };

    return String(str).replace(/[&<>"'`=\/]/g, (s) => {
        return entityMap[s];
    });
}

export const extractHTMLContent = (str) => {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return doc.documentElement.textContent;
}

export const maskNumber = (number) => {
    let hideNum = [];
    for(let i = 0; i < number.length; i++){
        if (i < number.length-4) {
            hideNum.push("*");
        } else {
            hideNum.push(number[i]);
        }
    }
    return hideNum.join("");
}

export const truncate = (str, limit) => {
    const truncated = str.substr(0, limit);
    if (truncated === str) {
        return truncated;
    }
    return truncated + '...';
}
